import { render } from "./HandlersView.vue?vue&type=template&id=339a79e7"
import script from "./HandlersView.vue?vue&type=script&lang=js"
export * from "./HandlersView.vue?vue&type=script&lang=js"

import exportComponent from "/gui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__